import React, { createContext } from 'react';

export const NavContext = createContext({
    isInView: '',
    isModalShow: false,
    setIsInView: () => {},
    setIsModalShow: () => {}
});
